import { Position } from '@trmediaab/zebra';
import {
  usePreventBodyScroll,
  useSafeLayoutEffect,
} from '@trmediaab/zebra-hooks';
import { useRef } from 'react';
import { createPortal } from 'react-dom';

import { useModalContext } from '../../utils/useModalContext';

interface ModalProps {
  children: React.ReactNode;
  preventBodyScroll?: boolean;
}

const Modal = ({ children, preventBodyScroll = false }: ModalProps) => {
  const modalId = useModalContext();
  const ref = useRef<HTMLDivElement>(null);

  usePreventBodyScroll(preventBodyScroll);

  useSafeLayoutEffect(() => {
    ref.current?.scrollIntoView(false);
  }, []);

  const modalContainer = document.querySelector(`[id="${modalId}"]`);

  if (modalContainer == null) {
    console.error('Could not find modal container');
    return null;
  }

  return createPortal(
    <>
      {/* eslint-disable-next-line @typescript-eslint/no-deprecated */}
      <Position.fixed
        ref={ref}
        zIndex="modal"
        top="0"
        left="0"
        width="100%"
        height="100%"
        bg="rgba(0, 0, 0, 0.5)"
      />
      <Position.absolute top="0" left="0" width="100%" zIndex="modal">
        {children}
      </Position.absolute>
    </>,
    modalContainer,
  );
};

export default Modal;
